import React from 'react';
import IconBase from './IconBase';
const OffsiteIcon = props => React.createElement(IconBase, props, React.createElement("g", null, React.createElement("defs", null, React.createElement("polygon", {
  points: "-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593 -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593 \t\t"
})), React.createElement("g", null, React.createElement("defs", null, React.createElement("rect", {
  x: "-688",
  y: "-3317",
  width: "1440",
  height: "6698"
})))), React.createElement("path", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M33.239,8.579 L19.658,8.675c-7.694,0-13.931,6.237-13.931,13.931V41.18c0,7.694,6.237,13.931,13.931,13.931h18.574 c7.694,0,13.931-6.237,13.931-13.931v-4.24"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x1: "39.313",
  y1: "32.952",
  x2: "58.271",
  y2: "13.994"
}), React.createElement("polyline", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "42.664,12.558 59.803,12.558 59.803,29.696 "
}));
OffsiteIcon.displayName = 'OffsiteIcon';
export default OffsiteIcon;
//# sourceMappingURL=OffsiteIcon.js.map